import "./OurMission.module.css";
import Header from "@/reusable_sections/Header";
import RefugeStory from "./sections/RefugeStory";
import Conservation from "./sections/Conservation";
import Advocates from "./sections/Advocates";
import Footer from "@/reusable_sections/Footer";
export default function OurMissionPage() {
  return <div>
      <Header />
      <RefugeStory />
      <Conservation />
      <Advocates />
      <Footer />
    </div>;
}